import { FormLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import Tooltip from '@mui/material/Tooltip'

import { Icon } from '#/components/Icon'
import Colors from '#/styles/Colors'
import Fonts from '#/styles/Fonts'

const Help = styled(Icon)({
  '.MuiInputLabel-shrink &': {
    transform: 'translate(0, 3px) scale(calc(1 + 1 / 3))',
  },
  'color': Colors.warning,
  'fontSize': Fonts.fontSize.M,
  'marginLeft': 5,
  'marginRight': 2,
})

const Content = styled('div')({
  alignItems: 'flex-start',
  cursor: 'help',
  display: 'inline-flex',
  position: 'relative',
})

const HelpContent = styled('div')({
  maxWidth: '100%',
  padding: '8px 4px 4px',
  width: 200,
})

const FormbuilderLabelWithHelp = ({ help, label }) => {
  if (help?.body && help?.title) {
    return (
      <FormLabel required={false}>
        <Tooltip
          arrow
          title={
            <HelpContent>
              <div style={{ color: Colors.warning, marginBottom: 10 }}>{help.title}</div>
              <div>{help.body}</div>
            </HelpContent>
          }
        >
          <Content>
            <div>{label}</div>
            <Help name="help-outline" />
          </Content>
        </Tooltip>
      </FormLabel>
    )
  }

  return label
}

export { FormbuilderLabelWithHelp }
